(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection-hero-password"] && !window.DesignMode) return;
  try {
    

const otherSections = document.querySelectorAll(".main .shopify-section, .seo-text.bg-neutral-lighter.align-c");
otherSections.forEach((section) => {
  if (!section.querySelector(".collection-hero-password")) {
    section.style.display = "none";
  }
});

document.querySelector('.shopify-section .video-section').parentElement.style.display = 'block';


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
let searchBtn = document.querySelectorAll(".js-search-trigger");
searchBtn.forEach(button => {
button.addEventListener("click", function (evt) {
evt.preventDefault();
let searchContent = document.querySelectorAll(".js-search-content")
searchContent.forEach(content => {
content.classList.toggle("show");
})
});
})

let searchClose = document.querySelectorAll(".cls");
searchClose.forEach(button => {
button.addEventListener("click", function (evt) {
evt.preventDefault();
let searchContent = document.querySelectorAll(".js-search-content")
searchContent.forEach(content => {
content.classList.remove("show");
})
});
})

  } catch(e) { console.error(e); }
})();

})();
